// NoIndexMeta.jsx
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const NoIndexMeta = () => {
  const location = useLocation();

  const noIndexPaths = [
    '/bopa',
    '/Documents',
    '/Legislacio',
    '/Pagines',
  ];

  const shouldNoIndex = noIndexPaths.some(path =>
    location.pathname.startsWith(path)
  );

  return (
    <Helmet>
      {shouldNoIndex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
};

export default NoIndexMeta;
